module.exports = __webpack_public_path__ + "static/media/nissan-navara.15f09163.webp";